// @components
import { Button } from 'antd';
import { RichText } from 'prismic-reactjs'
import ReactPlayer from 'react-player'

// @styles 
import './styles.scss'
import { Bounce, Fade } from 'react-reveal'

export default function Banner({ data, handleChange }) {
    const info = data.primary
    return (
        <div className='banner__container' id={info.idcontent}>
            <Fade bottom cascade delay={0.3}>
                <div className='container-xl'>
                    <div className='banner__container-text'>
                        {info.sectiontitle && (
                            <div className='banner__container-text-title'>
                                <RichText
                                    render={info.sectiontitle}
                                />
                            </div>
                        )}
                        {info.sectiondescription && (
                            <div className='banner__container-text-description'>
                                {info.sectiondescription ? info.sectiondescription : ""}
                            </div>
                        )}
                        {info.buttonname && (
                            <Bounce delay={8}>
                                <Button
                                    className='ant-btn-solid c-3 ant-btn-size-xs'
                                    onClick={() => handleChange(null)}
                                    data-testId={info.buttonname}
                                >
                                    <div>{info.buttonname}</div>
                                </Button>
                            </Bounce>
                        )}
                    </div>
                    <div className='banner__container-img'>
                        {info.image && info.image.url ?
                            <img
                                src={info.image && info.image.url ? info.image.url : ""}
                                alt={info?.image?.alt}
                            />
                            :
                            <ReactPlayer
                                url={info.video && info.video.url ? info.video.url : ""}
                                playing={true}
                                loop={true}
                                muted
                            />
                        }
                    </div>
                </div>
            </Fade>
        </div >
    )
}